import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2edc574d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "data-overview"
};
const _hoisted_2 = {
  class: "left-section"
};
const _hoisted_3 = {
  class: "stats-card basic-stats"
};
const _hoisted_4 = {
  class: "card-header"
};
const _hoisted_5 = {
  class: "stats-grid"
};
const _hoisted_6 = {
  class: "stat-item"
};
const _hoisted_7 = {
  class: "stat-icon"
};
const _hoisted_8 = {
  class: "stat-content"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stat-label"
}, "管网长度(km)", -1));
const _hoisted_10 = {
  class: "stat-value"
};
const _hoisted_11 = {
  class: "stat-item"
};
const _hoisted_12 = {
  class: "stat-icon"
};
const _hoisted_13 = {
  class: "stat-content"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stat-label"
}, "监测点数量", -1));
const _hoisted_15 = {
  class: "stat-value"
};
const _hoisted_16 = {
  class: "stat-item"
};
const _hoisted_17 = {
  class: "stat-icon"
};
const _hoisted_18 = {
  class: "stat-content"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stat-label"
}, "阀门数量", -1));
const _hoisted_20 = {
  class: "stat-value"
};
const _hoisted_21 = {
  class: "stat-item"
};
const _hoisted_22 = {
  class: "stat-icon"
};
const _hoisted_23 = {
  class: "stat-content"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stat-label"
}, "调压站数量", -1));
const _hoisted_25 = {
  class: "stat-value"
};
const _hoisted_26 = {
  class: "charts-row-2"
};
const _hoisted_27 = {
  class: "chart-card"
};
const _hoisted_28 = {
  class: "chart-header"
};
const _hoisted_29 = {
  class: "chart-card user-type-card"
};
const _hoisted_30 = {
  class: "chart-header"
};
const _hoisted_31 = {
  class: "user-type-content"
};
const _hoisted_32 = {
  class: "user-type-list"
};
const _hoisted_33 = {
  class: "user-info"
};
const _hoisted_34 = {
  class: "user-name"
};
const _hoisted_35 = {
  class: "user-stats"
};
const _hoisted_36 = {
  class: "user-value"
};
const _hoisted_37 = {
  class: "user-percentage"
};
const _hoisted_38 = {
  class: "charts-row-3"
};
const _hoisted_39 = {
  class: "chart-card"
};
const _hoisted_40 = {
  class: "chart-header"
};
const _hoisted_41 = {
  class: "chart-card"
};
const _hoisted_42 = {
  class: "chart-header"
};
const _hoisted_43 = {
  class: "right-section"
};
const _hoisted_44 = {
  class: "station-scroll-card"
};
const _hoisted_45 = {
  class: "card-header"
};
const _hoisted_46 = {
  class: "station-scroll-content"
};
const _hoisted_47 = {
  class: "station-icon"
};
const _hoisted_48 = {
  class: "station-info"
};
const _hoisted_49 = {
  class: "station-name"
};
const _hoisted_50 = {
  class: "alarm-card"
};
const _hoisted_51 = {
  class: "card-header"
};
const _hoisted_52 = {
  class: "alarm-content"
};
const _hoisted_53 = {
  class: "alarm-stats"
};
const _hoisted_54 = {
  class: "alarm-stat-item total"
};
const _hoisted_55 = {
  class: "stat-icon"
};
const _hoisted_56 = {
  class: "stat-info"
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stat-label"
}, "告警总数", -1));
const _hoisted_58 = {
  class: "stat-value"
};
const _hoisted_59 = {
  class: "alarm-stat-item high"
};
const _hoisted_60 = {
  class: "stat-icon"
};
const _hoisted_61 = {
  class: "stat-info"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stat-label"
}, "致命告警", -1));
const _hoisted_63 = {
  class: "stat-value"
};
const _hoisted_64 = {
  class: "alarm-stat-item normal"
};
const _hoisted_65 = {
  class: "stat-icon"
};
const _hoisted_66 = {
  class: "stat-info"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stat-label"
}, "一般告警", -1));
const _hoisted_68 = {
  class: "stat-value"
};
const _hoisted_69 = {
  class: "alarm-list"
};
const _hoisted_70 = {
  class: "alarm-scroll-container"
};
const _hoisted_71 = ["onClick"];
const _hoisted_72 = {
  class: "alarm-icon"
};
const _hoisted_73 = ["src"];
const _hoisted_74 = {
  class: "alarm-time"
};
const _hoisted_75 = {
  class: "alarm-title"
};
import { ref, reactive, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import vueSeamlessScroll from "vue-seamless-scroll/src";
import stationPng from '@/assets/img/mapcz.png';
import actuatorPng from '@/assets/img/mapzxq.png';
import pressurePng from '@/assets/img/mapyl.png';
import gasPng from '@/assets/img/mapkr.png';
import guandingzhuPng from '@/assets/img/guandingzhu.png';
import fajingPng from '@/assets/img/fajing.png';
import czxielouPng from '@/assets/img/cz.png';
import { getAlarmTrend, getData4, getData3, alarms } from '@/api/system1/data.js';
import { lgasStationList } from '@/api/station';
import { weChatrequest } from '@/utils/request';
import { DataBoard, Connection, Location, Setting, OfficeBuilding, TrendCharts, Monitor, Warning, PieChart, User, Shop } from '@element-plus/icons-vue';
import * as echarts from 'echarts';

// 注册vueSeamlessScroll组件

export default {
  __name: 'index',
  setup(__props) {
    const components = {
      vueSeamlessScroll
    };

    // 路由实例
    const router = useRouter();

    // 图表容器ref
    const userTypeChart = ref(null);
    const alarmTrendChart = ref(null);
    const deviceStatsChart = ref(null);
    const stationAlarmChart = ref(null);

    // ECharts实例
    let userTypeChartInstance = null;
    let alarmTrendChartInstance = null;
    let deviceStatsChartInstance = null;
    let stationAlarmChartInstance = null;

    // 用户类型数据
    const userTypeData = reactive([{
      name: '居民用户',
      value: 0,
      percentage: 0,
      color: '#3B82F6'
    }, {
      name: '商业用户',
      value: 0,
      percentage: 0,
      color: '#10B981'
    }, {
      name: '工业用户',
      value: 0,
      percentage: 0,
      color: '#F59E0B'
    }]);

    // 基础信息统计数据
    const basicStats = reactive({
      gwLengthKm: 0,
      jcdCount: 0,
      fmCount: 0,
      tyzCount: 0
    });

    // 场站列表数据
    const stationList = ref([]);
    const getSationList = function () {
      lgasStationList({
        pageNum: 1,
        pageSize: 100
      }).then(res => {
        if (res.code == 0) {
          // 清空原数组并添加新数据，保持响应性
          stationList.value = (res.data.records || []).map(item => {
            return {
              id: item.id,
              name: item.stationName
            };
          });
          console.log(stationList, 'stationList');
        }
      }).catch(() => {});
    };
    // 告警分析数据
    const alarmAnalysis = reactive({
      total: 0,
      fatalCount: 0,
      normalCount: 0,
      data: []
    });
    const getAlarms = () => {
      alarms().then(response => {
        if (response.code == 0) {
          // 根据接口返回的数据更新告警分析数据
          if (response.data) {
            // 映射接口数据到页面需要的格式
            alarmAnalysis.total = response.data.total || 0;
            alarmAnalysis.fatalCount = response.data.fatalCount || 0;
            alarmAnalysis.normalCount = response.data.normalCount || 0;

            // 转换告警列表数据格式
            if (response.data.data && Array.isArray(response.data.data)) {
              alarmAnalysis.data = response.data.data.map(item => {
                // 根据 severity 值确定告警级别
                let level, levelText;
                switch (item.severity) {
                  case 1:
                    level = 'fatal';
                    levelText = '致命';
                    break;
                  case 2:
                    level = 'severe';
                    levelText = '严重';
                    break;
                  case 3:
                    level = 'normal';
                    levelText = '一般';
                    break;
                  case 4:
                    level = 'tip';
                    levelText = '提示';
                    break;
                  default:
                    level = 'normal';
                    levelText = '一般';
                }
                return {
                  id: item.id || Date.now() + Math.random(),
                  // 使用原始id或生成唯一id
                  time: item.time,
                  title: item.name,
                  content: item.content,
                  type: item.type,
                  level: level,
                  levelText: levelText,
                  severity: item.severity,
                  deviceCode: item.deviceCode || '' // 保存设备编号
                };
              });
            }
          }
        }
      }).catch(error => {
        console.error('获取告警数据失败:', error);
      });
    };
    // 根据设备类型获取图标
    const getDeviceIcon = type => {
      const iconMap = {
        1: actuatorPng,
        // 执行器
        2: czxielouPng,
        // 场站泄漏
        3: fajingPng,
        // 阀井泄漏
        4: gasPng,
        // 管钉
        5: guandingzhuPng,
        // 管桩
        6: pressurePng,
        // 压力监测
        7: stationPng // 工商业
      };
      return iconMap[type] || '';
    };

    // 根据设备类型获取样式类名
    const getDeviceTypeClass = type => {
      const classMap = {
        1: 'device-executor',
        2: 'device-station',
        3: 'device-nail',
        4: 'device-pile'
      };
      return classMap[type] || 'device-default';
    };

    // 点击告警项跳转到告警管理页面
    const handleAlarmClick = alarm => {
      if (!alarm.deviceCode) {
        ElMessage.warning('该告警无设备编号信息');
        return;
      }
      // 跳转到告警管理页面，并传递设备编号参数
      router.push({
        path: '/alarmCommonManage',
        query: {
          deviceCode: alarm.deviceCode,
          isActive: 'alarmRealTime'
        }
      });
    };

    // 滚动配置
    const scrollOption = reactive({
      step: 0.5,
      // 数值越大,滚动越快
      limitMoveNum: 2,
      // 开始无缝滚动的数据量
      hoverStop: true,
      // 是否开启鼠标悬停stop
      direction: 1,
      // 0向下 1向上 2向左 3向右
      openWatch: true,
      // 开启数据实时监听
      singleHeight: 0,
      // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 3/4时生效
      singleWidth: 0,
      // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 3/4时生效
      waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
    });

    // 定时器
    let dataRefreshTimer = null;

    // 初始化图表
    const initCharts = () => {
      nextTick(() => {
        try {
          // 用户类型分析饼图
          if (userTypeChart.value) {
            userTypeChartInstance = echarts.init(userTypeChart.value);
            getData4().then(res => {
              let seriesData = [];
              if (res.code == 0) {
                seriesData = res.data;

                // 根据接口返回的数据更新 userTypeData
                const total = seriesData.jmCount + seriesData.syCount + seriesData.gyCount;
                userTypeData[0].value = seriesData.jmCount || 0;
                userTypeData[0].percentage = total ? Math.round(seriesData.jmCount / total * 100) : 0;
                userTypeData[1].value = seriesData.syCount || 0;
                userTypeData[1].percentage = total ? Math.round(seriesData.syCount / total * 100) : 0;
                userTypeData[2].value = seriesData.gyCount || 0;
                userTypeData[2].percentage = total ? Math.round(seriesData.gyCount / total * 100) : 0;
              }
              const userTypeOption = {
                tooltip: {
                  trigger: 'item',
                  formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                series: [{
                  name: '用户类型',
                  type: 'pie',
                  radius: ['50%', '75%'],
                  center: ['50%', '50%'],
                  data: [{
                    value: userTypeData[0].value,
                    name: '居民用户'
                  }, {
                    value: userTypeData[1].value,
                    name: '商业用户'
                  }, {
                    value: userTypeData[2].value,
                    name: '工业用户'
                  }],
                  itemStyle: {
                    borderRadius: 8,
                    borderColor: '#fff',
                    borderWidth: 2
                  },
                  label: {
                    show: false
                  },
                  labelLine: {
                    show: false
                  },
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  },
                  color: ['#3B82F6', '#10B981', '#F59E0B']
                }]
              };
              userTypeChartInstance.setOption(userTypeOption);
            }).catch(error => {
              console.error('获取用户类型分析失败:', error);
            });
          }

          // 最近一周报警趋势折线图
          if (alarmTrendChart.value) {
            alarmTrendChartInstance = echarts.init(alarmTrendChart.value);
            getAlarmTrend().then(res => {
              let xData = [];
              let seriesData = [];
              if (res.code == 0) {
                xData = res.data.dates;
                seriesData = res.data.totalAlarmCounts;
              }
              const alarmTrendOption = {
                tooltip: {
                  trigger: 'axis'
                },
                grid: {
                  left: '8%',
                  right: '8%',
                  bottom: '3%',
                  top: '10%',
                  containLabel: true
                },
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  data: xData,
                  axisLabel: {
                    fontSize: 11,
                    rotate: 40
                  }
                },
                yAxis: {
                  type: 'value',
                  axisLabel: {
                    fontSize: 12
                  }
                },
                series: [{
                  name: '报警数量',
                  type: 'line',
                  smooth: true,
                  data: seriesData,
                  areaStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [{
                        offset: 0,
                        color: 'rgba(250, 173, 20, 0.3)'
                      }, {
                        offset: 1,
                        color: 'rgba(250, 173, 20, 0.05)'
                      }]
                    }
                  },
                  itemStyle: {
                    color: '#FAAD14'
                  },
                  lineStyle: {
                    width: 3
                  }
                }]
              };
              alarmTrendChartInstance.setOption(alarmTrendOption);
            }).catch(error => {
              console.error('获取报警趋势失败:', error);
            });
          }
        } catch (error) {
          console.error('图表初始化失败:', error);
          ElMessage.error('图表初始化失败');
        }
      });
    };

    // 窗口大小改变时重新调整图表
    const handleResize = () => {
      if (userTypeChartInstance) userTypeChartInstance.resize();
      if (alarmTrendChartInstance) alarmTrendChartInstance.resize();
      if (deviceStatsChartInstance) deviceStatsChartInstance.resize();
      if (stationAlarmChartInstance) stationAlarmChartInstance.resize();
    };

    // 刷新所有数据的方法
    const refreshAllData = () => {
      getBasicStats();
      // getSationList()
      loadDeviceStats();
      initCharts();
      getAlarms();
    };

    // 启动定时器
    const startDataRefreshTimer = () => {
      // 清除已存在的定时器
      if (dataRefreshTimer) {
        clearInterval(dataRefreshTimer);
      }
      // 每10秒刷新一次数据
      dataRefreshTimer = setInterval(() => {
        refreshAllData();
      }, 10000);
    };

    // 停止定时器
    const stopDataRefreshTimer = () => {
      if (dataRefreshTimer) {
        clearInterval(dataRefreshTimer);
        dataRefreshTimer = null;
      }
    };
    // 获取基础信息统计数据
    const getBasicStats = () => {
      getData3().then(res => {
        if (res.code == 0) {
          // 更新 basicStats 的属性，保持响应性
          Object.assign(basicStats, res.data);
        }
      });
    };
    // 设备统计数据
    let deviceCountStats = ref([]);
    const loadDeviceStats = () => {
      weChatrequest({
        url: '/api/v1/map/device/status/stats',
        method: 'get'
      }).then(res => {
        if (res.data && res.data.deviceTypes) {
          // 清空之前的数据
          deviceCountStats.value = [];

          // 用于图表显示的标签和数据
          const xAxisData = [];
          const totalData = [];
          const alarmData = [];

          // 遍历接口返回的设备类型数据
          res.data.deviceTypes.forEach(item => {
            // 只处理需要展示的设备类型，排除"场站"和"场站激光云台泄露监测"
            if (item.count && !item.menuTypeName.includes('场站管理') && !item.menuTypeName.includes('场站激光云台泄露监测')) {
              // 提取显示名称（去掉"管理"后缀）
              const displayName = item.menuTypeName.replace('管理', '');
              xAxisData.push(displayName);
              totalData.push(item.count.total || 0);
              alarmData.push(item.count.alarmCount || 0);

              // 添加到统计数据中
              deviceCountStats.value.push({
                alarmCount: item.count.alarmCount || 0,
                total: item.count.total || 0
              });
            }
          });
          console.log(deviceCountStats, 'deviceCountStats--');
          nextTick(() => {
            // 设备统计柱状图
            if (deviceStatsChart.value) {
              deviceStatsChartInstance = echarts.init(deviceStatsChart.value);
              const deviceStatsOption = {
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'shadow'
                  }
                },
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  top: '10%',
                  containLabel: true
                },
                xAxis: {
                  type: 'category',
                  data: xAxisData,
                  axisLabel: {
                    fontSize: 11,
                    rotate: 30
                  }
                },
                yAxis: {
                  type: 'value',
                  axisLabel: {
                    fontSize: 12
                  }
                },
                series: [{
                  name: '设备数量',
                  type: 'bar',
                  data: totalData,
                  barWidth: '40%',
                  itemStyle: {
                    borderRadius: [8, 8, 0, 0],
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#83bff6'
                    }, {
                      offset: 1,
                      color: '#188df0'
                    }])
                  },
                  emphasis: {
                    itemStyle: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#2378f7'
                      }, {
                        offset: 1,
                        color: '#83bff6'
                      }])
                    }
                  },
                  label: {
                    show: true,
                    position: 'top',
                    fontSize: 11,
                    fontWeight: 600,
                    color: '#2378f7'
                  }
                }]
              };
              deviceStatsChartInstance.setOption(deviceStatsOption);
            }

            // 场站设备告警统计图表（单柱状图）
            if (stationAlarmChart.value) {
              stationAlarmChartInstance = echarts.init(stationAlarmChart.value);
              const stationAlarmOption = {
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'shadow'
                  },
                  formatter: function (params) {
                    return params[0].name + '<br/>' + params[0].marker + '告警数量: ' + params[0].value;
                  }
                },
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  top: '10%',
                  containLabel: true
                },
                xAxis: {
                  type: 'category',
                  data: xAxisData,
                  axisLabel: {
                    fontSize: 11,
                    rotate: 30
                  }
                },
                yAxis: {
                  type: 'value',
                  // name: '告警数量',
                  axisLabel: {
                    fontSize: 12
                  }
                },
                series: [{
                  name: '告警数量',
                  type: 'bar',
                  data: alarmData,
                  barWidth: '50%',
                  itemStyle: {
                    borderRadius: [8, 8, 0, 0],
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#FF6B6B'
                    }, {
                      offset: 0.5,
                      color: '#FF8E8E'
                    }, {
                      offset: 1,
                      color: '#FFAAAA'
                    }])
                  },
                  emphasis: {
                    itemStyle: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#FF4D4F'
                      }, {
                        offset: 0.5,
                        color: '#FF7875'
                      }, {
                        offset: 1,
                        color: '#FFA39E'
                      }])
                    }
                  },
                  label: {
                    show: true,
                    position: 'top',
                    fontSize: 11,
                    fontWeight: 600,
                    color: '#FF4D4F'
                  }
                }]
              };
              stationAlarmChartInstance.setOption(stationAlarmOption);
            }
          });
        }
      }).catch(err => {
        console.error('获取设备统计失败:', err);
      });
    };
    onMounted(() => {
      window.addEventListener('resize', handleResize);
      // 初始化加载数据
      refreshAllData();
      // 启动定时器
      startDataRefreshTimer();
    });
    onBeforeUnmount(() => {
      // 停止定时器
      stopDataRefreshTimer();
      // 销毁图表实例
      if (userTypeChartInstance) userTypeChartInstance.dispose();
      if (alarmTrendChartInstance) alarmTrendChartInstance.dispose();
      if (deviceStatsChartInstance) deviceStatsChartInstance.dispose();
      if (stationAlarmChartInstance) stationAlarmChartInstance.dispose();
      window.removeEventListener('resize', handleResize);
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h3", null, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(DataBoard))]),
        _: 1
      }), _createTextVNode(" 基础信息统计 ")])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Connection))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(basicStats.gwLengthKm), 1)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Location))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, _toDisplayString(basicStats.jcdCount), 1)])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Setting))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, _toDisplayString(basicStats.fmCount), 1)])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(OfficeBuilding))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, _toDisplayString(basicStats.tyzCount), 1)])])])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("h3", null, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(TrendCharts))]),
        _: 1
      }), _createTextVNode(" 最近一周报警趋势 ")])]), _createElementVNode("div", {
        ref_key: "alarmTrendChart",
        ref: alarmTrendChart,
        class: "chart-container"
      }, null, 512)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("h3", null, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(PieChart))]),
        _: 1
      }), _createTextVNode(" 用户类型分析 ")])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", {
        ref_key: "userTypeChart",
        ref: userTypeChart,
        class: "user-type-chart"
      }, null, 512), _createElementVNode("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userTypeData, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "user-item",
          key: index
        }, [_createElementVNode("div", {
          class: "user-icon",
          style: _normalizeStyle({
            backgroundColor: item.color
          })
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [item.name === '居民用户' ? (_openBlock(), _createBlock(_unref(User), {
            key: 0
          })) : item.name === '商业用户' ? (_openBlock(), _createBlock(_unref(Shop), {
            key: 1
          })) : (_openBlock(), _createBlock(_unref(OfficeBuilding), {
            key: 2
          }))]),
          _: 2
        }, 1024)], 4), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_35, [_createElementVNode("span", _hoisted_36, _toDisplayString(item.value), 1), _createElementVNode("span", _hoisted_37, _toDisplayString(item.percentage) + "%", 1)])])]);
      }), 128))])])])]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("h3", null, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Monitor))]),
        _: 1
      }), _createTextVNode(" 设备统计 ")])]), _createElementVNode("div", {
        ref_key: "deviceStatsChart",
        ref: deviceStatsChart,
        class: "chart-container"
      }, null, 512)]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("h3", null, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(OfficeBuilding))]),
        _: 1
      }), _createTextVNode(" 设备告警统计 ")])]), _createElementVNode("div", {
        ref_key: "stationAlarmChart",
        ref: stationAlarmChart,
        class: "chart-container"
      }, null, 512)])])]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("h3", null, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(OfficeBuilding))]),
        _: 1
      }), _createTextVNode(" 场站列表 ")])]), _createElementVNode("div", _hoisted_46, [_createVNode(_unref(vueSeamlessScroll), {
        data: stationList.value,
        "class-option": scrollOption,
        class: "seamless-warp"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stationList.value, station => {
          return _openBlock(), _createElementBlock("div", {
            class: "station-item",
            key: station.id
          }, [_createElementVNode("div", _hoisted_47, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(OfficeBuilding))]),
            _: 1
          })]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, _toDisplayString(station.name), 1)])]);
        }), 128))]),
        _: 1
      }, 8, ["data", "class-option"])])]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("h3", null, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Warning))]),
        _: 1
      }), _createTextVNode(" 设备告警分析 ")])]), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Warning))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_56, [_hoisted_57, _createElementVNode("div", _hoisted_58, _toDisplayString(alarmAnalysis.total), 1)])]), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Warning))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_61, [_hoisted_62, _createElementVNode("div", _hoisted_63, _toDisplayString(alarmAnalysis.fatalCount), 1)])]), _createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Warning))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_66, [_hoisted_67, _createElementVNode("div", _hoisted_68, _toDisplayString(alarmAnalysis.normalCount), 1)])])]), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, [_createVNode(_unref(vueSeamlessScroll), {
        data: alarmAnalysis.data,
        "class-option": scrollOption,
        class: "seamless-warp"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alarmAnalysis.data, alarm => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["alarm-item", getDeviceTypeClass(alarm.type)]),
            key: alarm.id,
            onClick: $event => handleAlarmClick(alarm)
          }, [_createElementVNode("div", _hoisted_72, [_createElementVNode("img", {
            src: getDeviceIcon(alarm.type)
          }, null, 8, _hoisted_73)]), _createElementVNode("div", _hoisted_74, _toDisplayString(alarm.time), 1), _createElementVNode("div", _hoisted_75, _toDisplayString(alarm.title), 1), _createElementVNode("div", {
            class: _normalizeClass(["alarm-level", `level-${alarm.level}`])
          }, _toDisplayString(alarm.levelText), 3)], 10, _hoisted_71);
        }), 128))]),
        _: 1
      }, 8, ["data", "class-option"])])])])])])]);
    };
  }
};